import React from 'react';

interface FilterChipProps {
    label: string;
    active: boolean;
    locked?: boolean;
    title?: string;
    href?: string;
    hrefLabel?: string;
    onClick?: () => void;
}

const ExternalLinkIcon: React.FC = () => (
    <svg className="filter-chip-link-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
            fill="currentColor"
            d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42 9.3-9.29H14V3zM5 5h6v2H7v10h10v-4h2v6H5V5z"
        />
    </svg>
);

const FilterChip: React.FC<FilterChipProps> = ({ label, active, locked = false, title, href, hrefLabel, onClick }) => {
    const className = `filter-chip${active ? ' is-active' : ''}${locked ? ' is-locked' : ''}`;

    const handleClick = () => {
        if (locked || !onClick) {
            return;
        }
        onClick();
    };

    return (
        <span className={className} title={title}>
            <button
                type="button"
                className="filter-chip-button"
                aria-pressed={active}
                aria-disabled={locked || !onClick}
                onClick={handleClick}
            >
                {label}
            </button>
            {href && (
                <a
                    className="filter-chip-link"
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={hrefLabel ?? `Open ${label} on Warcraft Logs`}
                    title={hrefLabel ?? 'Open Warcraft Logs report'}
                    onClick={(event) => {
                        event.stopPropagation();
                    }}
                >
                    <ExternalLinkIcon />
                </a>
            )}
        </span>
    );
};

export default FilterChip;
